import { useAutocompleteSource } from '@eas/common-web';
import { FormTemplateAutocomplete } from '@models';
import { EvidenceApiUrl } from '@enums';

export function useFormTemplates() {
  return useAutocompleteSource<FormTemplateAutocomplete>({
    url: `${EvidenceApiUrl.FORM_TEMPLATES}/list`,
  });
}
